import React, { useEffect, useState } from 'react';
import { PiBell } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import { FaCaretDown, FaCaretRight, FaCaretUp } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { actionDoctor } from '../../redux/actions';

const HeadingPage1 = ({ pageHeading }) => {
    const patient_access = JSON.parse(localStorage.getItem("patient_access"));
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        dispatch(actionDoctor.getChatNotification(patient_access?.userGuid, 'EUR', 1));
    }, [dispatch, patient_access?.userGuid]);

    const getChatNotificationData = useSelector(
        (state) => state.doctor.getChatNotificationData?.data
    );

    return (
        <section className='heading-page'>
            <div>
                <h2 className='exado-subTitle-one'>{pageHeading}</h2>
            </div>
            <div className="notification-dropdown">
                <div className="notification-drpDwnText" onClick={toggleDropdown}>
                    <div className="notification-belltxt">
                        <PiBell className="bell-icon" /> {t("notification")}
                    </div>
                    {isDropdownOpen ? (
                        <FaCaretUp className="arrow-icn" />
                    ) : (
                        <FaCaretDown className="arrow-icn" />
                    )}
                </div>
                {isDropdownOpen && (
                    <div className="notification-menu">
                        <h5 className="notification-menu-heading"><span className='exado-title-seven nmh-notification'>{t("notification")}</span><span className='exado_body_text_three maar-notification'>{t("mark_all_as_read")}</span></h5>
                        <ul className='notification-sub-menu'>
                            <li>
                                <h6 className='exado_body_text_three' >{t("Message") + " " + t("notification")}</h6>
                                <ul className='notification-ul'>
                                    {getChatNotificationData?.result?.map((items, index) =>
                                    (
                                        <li className='notification-li' key={index}>
                                            <div className='notification-li-sub exado_body_text_two'>
                                                <snap className='position-relative ot-icn-blk'>
                                                    <PiBell className='not-icn' />
                                                    {!items.isRead && (
                                                        <span className="p-1 bg-danger border border-light rounded-circle red-dot">
                                                            <span className="visually-hidden"></span>
                                                        </span>
                                                    )}

                                                </snap>

                                                {t("new_message")} <span className='exado_body_text_two'>{items.doctorName}</span></div> <FaCaretRight />
                                        </li>
                                    ))}

                                </ul>
                            </li>
                        </ul>
                        <h5 className="notification-menu-footer">{t("all_notifications")}</h5>
                    </div>
                )}

            </div>
        </section>
    )
}

export default HeadingPage1;
